import {
  useAppNavigate,
  makeUrl,
  useAppLocation,
  HighLightBannerConfig,
  ButtonTargetEnum,
} from "@commons-monorepo/index";
import { useCallback } from "react";

export const useBannerNavigation = (config: HighLightBannerConfig) => {
  const navigate = useAppNavigate();
  const { pathname } = useAppLocation();

  return useCallback(
    (source?: ButtonTargetEnum) => {
      switch (source) {
        case ButtonTargetEnum.about_us:
          navigate(makeUrl(pathname, `sobre-nosotros`));
          break;
        case ButtonTargetEnum.product:
          navigate(
            makeUrl(
              pathname,
              config?.product_id
                ? `producto/${config?.product_id}`
                : `todos-los-productos`,
            ),
          );
          break;
        case ButtonTargetEnum.category:
          navigate(
            makeUrl(
              pathname,
              config?.category_id
                ? `categoria/${config?.category_id}`
                : `todos-los-productos`,
            ),
          );
          break;
        case ButtonTargetEnum.offers:
          navigate(makeUrl(pathname, `ofertas`));
          break;
        case ButtonTargetEnum.wholesale:
          navigate(makeUrl(pathname, `ventas-mayoreo`));
          break;
        case ButtonTargetEnum.services:
          navigate(makeUrl(pathname, `servicios`));
          break;
        case ButtonTargetEnum.all:
          navigate(makeUrl(pathname, `todos-los-productos`));
          break;
        default:
          navigate(pathname);
          break;
      }
    },
    [navigate, pathname, config],
  );
};
